<template>
  <n-drawer v-bind="$attrs">
    <n-drawer-content v-bind="drawerContentProps">
      <slot></slot>
    </n-drawer-content>
  </n-drawer>
</template>
<script setup lang="ts">
import type { DrawerContentProps } from 'naive-ui'
import { NDrawer, NDrawerContent } from 'naive-ui'

defineProps<{
  drawerContentProps?: Partial<DrawerContentProps>
}>()
</script>
